import { startCountdown } from '@js/pages/rzut-przed-meczem/countdown';
import { createGame } from '@js/pages/rzut-przed-meczem/game';
import { initOffer } from '@js/pages/rzut-przed-meczem/offer';
import { createResult, isPoolExhausted } from '@js/pages/rzut-przed-meczem/result';

// Landing "Rzut przed meczem" - konfiguracja i komunikaty przychodzą z Twiga (#rpm-data).

const byId = (id) => document.getElementById(id);

function readConfig() {
    const el = byId('rpm-data');

    if (!el) {
        return null;
    }

    try {
        return JSON.parse(el.textContent);
    } catch (err) {
        console.error('[rzut-przed-meczem] Niepoprawny JSON w #rpm-data', err);

        return null;
    }
}

function init() {
    const config = readConfig();
    const canvas = byId('rpm-court');

    if (!config) {
        return;
    }

    initOffer(config);

    if (!canvas) {
        return;
    }

    const { texts } = config;

    const veil = {
        root: byId('rpm-veil'),
        title: byId('rpm-veil-title'),
        text: byId('rpm-veil-text'),
        button: byId('rpm-veil-button'),
        limit: byId('rpm-veil-limit'),
        note: byId('rpm-veil-note'),
    };

    // Gra jest otwarta zawsze. Po wyczerpaniu puli zasłona mówi tylko, że gramy bez vouchera.
    const markPoolExhausted = () => {
        veil.limit.hidden = true;
        veil.note.textContent = texts.pool_note;
    };

    const result = createResult({
        config,
        onPoolExhausted: markPoolExhausted,
        el: {
            root: byId('rpm-result'),
            label: byId('rpm-result-label'),
            title: byId('rpm-result-title'),
            text: byId('rpm-result-text'),
            form: byId('rpm-form'),
            fields: Object.fromEntries(
                ['name', 'email', 'phone', 'rules', 'marketing'].map((key) => [
                    key,
                    {
                        wrap: byId(`rpm-${key}-field`),
                        input: byId(`rpm-${key}`),
                        error: byId(`rpm-${key}-error`),
                    },
                ])
            ),
            submit: byId('rpm-submit'),
            error: byId('rpm-form-error'),
            sent: byId('rpm-sent'),
            sentEmail: byId('rpm-sent-email'),
        },
    });

    const game = createGame({
        config,
        onEnd: (points) => result.show(points),
        el: {
            canvas,
            stage: byId('rpm-stage'),
            toast: byId('rpm-toast'),
            time: byId('rpm-hud-time'),
            points: byId('rpm-hud-points'),
            best: byId('rpm-hud-best'),
            bar: byId('rpm-hud-bar'),
        },
    });

    const start = () => {
        game.start();
        veil.root.hidden = true;
        result.hide();
    };

    veil.button.addEventListener('click', start);

    byId('rpm-again').addEventListener('click', () => {
        start();
        byId('rpm-game').scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    startCountdown(
        byId('rpm-countdown'),
        byId('rpm-countdown-wrap'),
        new Date(config.tipoff).getTime(),
        texts
    );

    if (isPoolExhausted()) {
        markPoolExhausted();
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
